import React from 'react'
import './index.scss'

/**
 * Component for showing Resource Type Icon
 * @param {boolean} isIconExists -  True if icon is present, otherwise false
 * @param {string} iconUrl - Url of icon
 */
const ResourceTypeListIcon = ({ isIconExists, iconUrl, children }) => {
  const CSS_CLASSNAME_PREFIX = 'resource-type-list'

  return (
    <div className={CSS_CLASSNAME_PREFIX}>
      {/* Checking if field is exist in the proviced data array */}
      {isIconExists && (
        <div className={`${CSS_CLASSNAME_PREFIX}-icon`}>
          {iconUrl && (
            <img
              src={iconUrl}
              alt="icon"
              className={`${CSS_CLASSNAME_PREFIX}-icon-style`}
            />
          )}
        </div>
      )}
      {children}
    </div>
  )
}
export default ResourceTypeListIcon
